import clsx from 'clsx';
import { LuMousePointerClick } from 'react-icons/lu';

interface TouchCounterProps {
  className?: string;
  buttonClassName?: string;
  count: number;
  setCount: (count: number) => void;
  limit: number;
  color?: 'green' | 'red';
}

export const TouchCounter = ({
  className,
  buttonClassName,
  count,
  setCount,
  limit,
  color = 'green',
}: TouchCounterProps) => {
  const tryIncrementCount = () => {
    if (count >= limit) {
      return;
    }

    setCount(count + 1);
  };

  return (
    <div className={clsx('w-28 h-28', className)}>
      <button
        className={clsx(
          'items-center justify-center',
          'text-white h-full w-full rounded-full shadow-2xl flex active:shadow-none',
          color === 'green' && 'bg-green-dark hover:bg-green-darker',
          color === 'red' && 'bg-red-dark hover:bg-red-darker',
          buttonClassName,
        )}
        onClick={() => tryIncrementCount()}
      >
        <LuMousePointerClick className="w-16 h-16" />
      </button>
    </div>
  );
};
